import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { API_BASE_URL } from '../config';
import { walletSessionService } from './walletSessionService';

// API base configuration
const apiConfig: AxiosRequestConfig = {
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
};

// Create an Axios instance
const apiClient: AxiosInstance = axios.create(apiConfig);

// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Dynamically add session token if available
    try {
      const sessionToken = walletSessionService.getSessionToken();
      
      if (sessionToken) {
        // Add session token as Bearer token
        config.headers = config.headers || {};
        config.headers['Authorization'] = `Bearer ${sessionToken}`;
        
        // Also add as X-Session-Token header for compatibility
        config.headers['X-Session-Token'] = sessionToken;
      }
    } catch (error) {
      // Silently fail if wallet session service is not available
      console.debug('Wallet session service not available for request:', error);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle authentication errors
    if (error.response?.status === 401) {
      // Clear invalid session token
      try {
        walletSessionService.clearSession();
        console.warn('Session token expired or invalid, cleared from storage');
      } catch (clearError) {
        console.debug('Could not clear session:', clearError);
      }
    }
    
    // Global error handling
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default apiClient; 